import styled, { keyframes } from 'styled-components';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor } from '@/theme/ai';

export const RailsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
  align-items: stretch;
  margin-top: 34px;

  ${screen.lg} {
    grid-template-columns: 1fr 1fr;
    gap: 28px;
    margin-top: 42px;
  }
`;

export const RailCard = styled.div`
  border: 1px solid ${homeColor.line};
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.025);
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const DiagramSvg = styled.svg`
  width: 100%;
  display: block;
`;

const dash = keyframes`
  to { stroke-dashoffset: -30; }
`;

export const FlowPath = styled.path`
  stroke-dasharray: 2 8;
  animation: ${dash} 1.1s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const RailStack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const StepRow = styled.div`
  display: flex;
  gap: 14px;
  padding: 18px 0;
  border-top: 1px solid ${homeColor.carbon};

  &:last-child {
    border-bottom: 1px solid ${homeColor.carbon};
  }
`;

export const StepNumber = styled.span`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.green};
  flex: none;
`;

export const StepTitle = styled.p`
  font-family: ${getToken('font-family-default')};
  font-weight: 600;
  color: ${homeColor.white};
  margin: 0 0 3px;
`;

export const StepDescription = styled.p`
  font-family: ${getToken('font-family-default')};
  color: ${homeColor.muted};
  font-size: 15px;
  margin: 0;
`;
